import React from "react";
import ReactDOM from "react-dom";
import Monogram from "./Monogram";
import MonogramContext from "./MonogramContext";
import { createRoot } from "react-dom/client";

const data = JSON.parse(document.querySelector("[data-monogram-data]").textContent);
const monogramRoot = document.getElementById("monogram-root");

if (monogramRoot) {
  const root = createRoot(monogramRoot);
  root.render(
    <React.StrictMode>
      <MonogramContext data={data}>
        <Monogram />
      </MonogramContext>
    </React.StrictMode>
  );
}
